export const TRANSLATIONS_ACTIONS = {
  FETCH_TRANSLATIONS: 'TRANSLATIONS/FETCH_TRANSLATIONS',
  FETCH_TRANSLATIONS_SUCCESS: 'TRANSLATIONS/FETCH_TRANSLATIONS_SUCCESS',
  FETCH_TRANSLATIONS_ERROR: 'TRANSLATIONS/FETCH_TRANSLATIONS_ERROR',
};
